import React, { useState, useEffect } from 'react';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import { ProducerCreateForm } from '../../components/producers/producer-create-form';
import { logAuditUI } from '../../utils/auditLogger';

function NewProducers() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        logAuditUI({
            actionType: 'OPEN_FORM',
            module: 'Producatori',
            description: 'A deschis formularul de adăugare producător nou',
        });
    }, []);

    return (
        <div className="flex h-screen overflow-hidden">

            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto ">
                {/*  Site header */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        {/* Dashboard actions */}
                        <div className="sm:flex sm:justify-between sm:items-center mb-8">

                            {/* Left: Title */}
                            <div className="mb-4 sm:mb-0">
                                <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Adauga producator</h1>
                            </div>
                            <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">

                                {/* Add view button */}

                            </div>
                        </div>
                        <ProducerCreateForm />
                    </div>
                </main>

                {/* <Banner /> */}

            </div>
        </div>
    );
}

export default NewProducers;